/*import React, {useState, useCallback, useRef} from 'react';
import "./Login.css";
import { Link, useNavigate} from "react-router-dom";
import { auth, firestore, browserSessionPersistence } from './firebase';
import { setPersistence, createUserWithEmailAndPassword, sendEmailVerification, updateProfile } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { Autocomplete, useJsApiLoader } from '@react-google-maps/api';
import { toast } from 'react-toastify';

const libraries = ['places'];


function Sign_in() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [indirizzo, setIndirizzo] = useState('');
    const [citta, setCitta] = useState('');
    const [cap, setCap] = useState('');
    const [lat, setLat] = useState(null);
    const [lng, setLng] = useState(null);


    const { isLoaded } = useJsApiLoader({
      id: 'google-map-script',
      googleMapsApiKey: "AIzaSyDcaOoEhIVyYuzQpmvOra7iZbbC_rXQi-A", 
      libraries,
    });

  
    const autocompleteRef = useRef(null);
  
    const onLoad = useCallback((autocomplete) => {
        autocompleteRef.current = autocomplete;
    }, []);
  
    const onPlaceChanged = useCallback(() => {
        if (autocompleteRef.current !== null) {
            const place = autocompleteRef.current.getPlace();

            if (!place || !place.geometry || typeof place !== 'object') {
                toast.error("Luogo non valido selezionato.", {autoClose: 5000});
                return;
            }
            
            const newLat = place.geometry.location.lat();
            const newLng = place.geometry.location.lng();
            const newAddress = place.formatted_address;

            setIndirizzo(newAddress);
            setLat(newLat);
            setLng(newLng);

            let postalCode = "";
            let locality = "";

            place.address_components.forEach((c) => {
                if (c.types.includes("postal_code")) postalCode = c.long_name;
                if (c.types.includes("locality")) locality = c.long_name;
            });

            setCap(postalCode);
            setCitta(locality);

        } else {
            console.log('Autocomplete non ancora caricato!');
        }
    }, [setIndirizzo, setLat, setLng, setCap, setCitta]);


    
    const Registrati = async (e) => {
      e.preventDefault();

      console.log("5. Funzione Registrati avviata.");
    
      if (!name || !surname || !email || !password || !indirizzo) {
        toast.error("Compila tutti i campi obbligatori!", { autoClose: 5000 });
        return;
      }

      if (lat === null || lng === null) {
        toast.error("Per favore, seleziona un indirizzo valido dai suggerimenti dati.", { autoClose: 5000 });
        toast.warn("Non è possibile creare un account con un indirizzo al di fuori dell’Italia, poiché al momento non effettuiamo spedizioni internazionali.", {autoClose: 10000});
        return;
      }
    
      const passwordRegex = /^(?=.*[A-Z])(?=.*\d).{6,}$/;
      if (!passwordRegex.test(password)) {
        toast.error("La password deve contenere almeno 6 caratteri, 1 maiuscola e 1 numero", { autoClose: 5000 });
        return;
      }

      console.log("6. Dati salvati (lat/lng):", { latitudine: lat, longitudine: lng });
    
      try {
        await setPersistence(auth, browserSessionPersistence);
        const authUser = await createUserWithEmailAndPassword(auth, email, password);
        await updateProfile(authUser.user, { displayName: `${name} ${surname}` });
        await setDoc(doc(firestore, "users", authUser.user.uid), {
          name,
          surname,
          indirizzo,
          CAP: cap,
          citta: citta,
          latitudine: lat,
          longitudine: lng,
          email,
          emailVerified: authUser.user.emailVerified
        });
        await sendEmailVerification(authUser.user);
        toast.success("Registrazione completata! Ti abbiamo inviato un'email di verifica. Controlla la tua casella di posta (anche nello spam).", { autoClose: 5000 });
        await auth.signOut();
    
        navigate('/login');
      } catch (error) {
        console.error("Errore durante la registrazione:", error);

        switch (error.code) {
          case 'auth/email-already-in-use':
            toast.error("Questa e-mail è già registrata. Prova ad accedere o inserisci un altro indirizzo.", { autoClose: 5000 });
            break;
          case 'auth/invalid-email':
            toast.error("L'indirizzo e-mail inserito non è valido.", { autoClose: 5000 });
            break;
          case 'auth/weak-password':
            toast.error("La password inserita è troppo debole.", { autoClose: 5000 });
            break;
          default:
            toast.error("Si è verificato un errore durante la registrazione. Riprova più tardi.", { autoClose: 5000 });
            break;
        }
      }
    };
        

  return (
    <div className='body'>
      <div className='login'>
        <Link to="/"><img className="login_logo" src="/logo_cinque.png" alt='Logo'/></Link>

        <div className='login_container'>
          <h1>Registrati</h1>
          <form onSubmit={Registrati}>
              <h5>Nome</h5>
              <input type='text' placeholder='Inserisci il tuo nome' value={name} onChange={e => setName(e.target.value)}/>

              <h5>Cognome</h5>
              <input type='text' placeholder='Inserisci il tuo cognome' value={surname} onChange={e => setSurname(e.target.value)}/>

              <h5>Indirizzo</h5>
              {isLoaded ? (
                <Autocomplete
                  onLoad={onLoad}
                  onPlaceChanged={onPlaceChanged}
                  options={{
                      componentRestrictions: { country: 'it' },
                  }}
                >
                  <input 
                    type='text'
                    placeholder='Inserisci il tuo indirizzo'
                    value={indirizzo}
                    onChange={e => setIndirizzo(e.target.value)}
                    style={{
                      width: "90%",
                      height: "40px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "8px"
                    }}
                  />
                </Autocomplete>
              ) : (
                <input 
                    type='text' 
                    placeholder="Caricamento Mappe..."
                    disabled
                    style={{
                      width: "100%",
                      height: "40px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "8px"
                    }}
                />
              )}

              <h5>E-mail</h5>
              <input type='email' placeholder='Inserisci la tua e-mail' value={email} onChange={e => setEmail(e.target.value)}/>

              <h5>Password</h5>
              <input type='password' placeholder='Inserisci la password' value={password} onChange={e => setPassword(e.target.value)}/>

              <button type='submit' className='loginButton'>registrati</button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Sign_in*/

import React, { useState, useCallback, useRef } from 'react';
import "./Login.css";
import { Link, useNavigate } from "react-router-dom";
import { auth, firestore, browserSessionPersistence } from './firebase';
import { setPersistence, createUserWithEmailAndPassword, sendEmailVerification, updateProfile } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { Autocomplete, useJsApiLoader } from '@react-google-maps/api';
import { toast } from 'react-toastify';

const libraries = ['places'];

function Sign_in() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [PI, setPI] = useState('');
    const [CF, setCF] = useState('');
    const [indirizzo, setIndirizzo] = useState('');
    const [citta, setCitta] = useState('');
    const [cap, setCap] = useState('');
    const [lat, setLat] = useState(null);
    const [lng, setLng] = useState(null);

    // STATI TERMINI E PRIVACY
    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false);

    const { isLoaded } = useJsApiLoader({
      id: 'google-map-script',
      googleMapsApiKey: "AIzaSyDcaOoEhIVyYuzQpmvOra7iZbbC_rXQi-A", 
      libraries,
    });

    const autocompleteRef = useRef(null);

    const onLoad = useCallback((autocomplete) => {
        autocompleteRef.current = autocomplete;
    }, []);

    const onPlaceChanged = useCallback(() => {
        if (autocompleteRef.current !== null) {
            const place = autocompleteRef.current.getPlace();

            if (!place || !place.geometry || typeof place !== 'object') {
                toast.error("Luogo non valido selezionato.", { autoClose: 5000 });
                return;
            }
            
            const newLat = place.geometry.location.lat();
            const newLng = place.geometry.location.lng();
            const newAddress = place.formatted_address;

            setIndirizzo(newAddress);
            setLat(newLat);
            setLng(newLng);

            let postalCode = "";
            let locality = "";

            if (place.address_components) {
                place.address_components.forEach((c) => {
                    if (c.types.includes("postal_code")) postalCode = c.long_name;
                    if (c.types.includes("locality")) locality = c.long_name;
                });
            }

            setCap(postalCode);
            setCitta(locality);

        } else {
            console.log('Autocomplete non ancora caricato!');
        }
    }, []);

    const Registrati = async (e) => {
      e.preventDefault();

      if (!name || !surname || !email || !password || !indirizzo || !CF) {
        toast.error("Compila tutti i campi obbligatori!", { autoClose: 5000 });
        return;
      }

      if (!PI) {
        toast.error("Se non hai una PI inserisci il CF in quella casella!", { autoClose: 5000 });
        return;
      }
      
      if (PI.length !== 11 && PI.length !== 16) {
        toast.error("La lunghezza della partita IVA è sbagliata!", { autoClose: 5000 });
        return;
      }

      if (CF.length !== 16) {
        toast.error("Il codice fiscale deve essere lungo 16 caratteri!", { autoClose: 5000 });
        return;
      }

      if (lat === null || lng === null) {
        toast.error("Per favore, seleziona un indirizzo valido dai suggerimenti dati.", { autoClose: 5000 });
        toast.warn("Non è possibile creare un account con un indirizzo al di fuori dell’Italia, poiché al momento non effettuiamo spedizioni internazionali.", {autoClose: 10000});
        return;
      }
    
      const passwordRegex = /^(?=.*[A-Z])(?=.*\d).{6,}$/;
      if (!passwordRegex.test(password)) {
        toast.error("La password deve contenere almeno 6 caratteri, 1 maiuscola e 1 numero", { autoClose: 5000 });
        return;
      }

      // Validazione obbligatoria dei consensi
      if (!privacyAccepted || !termsAccepted) {
        toast.error("Devi accettare sia l'Informativa Privacy sia i Termini e Condizioni per registrarti.", { autoClose: 5000 });
        return;
      }

      try {
        await setPersistence(auth, browserSessionPersistence);
        const authUser = await createUserWithEmailAndPassword(auth, email, password);
        await updateProfile(authUser.user, { displayName: `${name} ${surname}` });
        
        await setDoc(doc(firestore, "users", authUser.user.uid), {
          name,
          surname,
          PI,
          CF,
          indirizzo,
          CAP: cap,
          citta: citta,
          latitudine: lat,
          longitudine: lng,
          email,
          emailVerified: authUser.user.emailVerified,
          privacyAcceptedAt: new Date().toISOString(),
          termsAcceptedAt: new Date().toISOString()
        });
        
        await sendEmailVerification(authUser.user);
        toast.success("Registrazione completata! Ti abbiamo inviato un'email di verifica. Controlla la tua casella di posta (anche nello spam).", { autoClose: 5000 });
        await auth.signOut();
    
        navigate('/login');
      } catch (error) {
        console.error("Errore durante la registrazione:", error);

        setLat(null);
        setLng(null);
        setCap('');
        setCitta('');
        setIndirizzo('');

        switch (error.code) {
          case 'auth/email-already-in-use':
            toast.error("Questa e-mail è già registrata. Prova ad accedere o inserisci un altro indirizzo.", { autoClose: 5000 });
            break;
          case 'auth/invalid-email':
            toast.error("L'indirizzo e-mail inserito non è valido.", { autoClose: 5000 });
            break;
          case 'auth/weak-password':
            toast.error("La password inserita è troppo debole.", { autoClose: 5000 });
            break;
          default:
            toast.error("Si è verificato un errore durante la registrazione. Riprova più tardi.", { autoClose: 5000 });
            break;
        }
      }
    };

    const isFormReady = privacyAccepted && termsAccepted;

    return (
      <div className='body'>
        <div className='login'>
          <Link to="/"><img className="login_logo" src="/logo_cinque.png" alt='Logo'/></Link>

          <div className='login_container'>
            <h1>Registrati</h1>
            <form onSubmit={Registrati}>
                <h5>Nome</h5>
                <input 
                  type='text' 
                  placeholder='Inserisci il tuo nome' 
                  value={name} 
                  onChange={e => setName(e.target.value)}
                />

                <h5>Cognome</h5>
                <input 
                  type='text' 
                  placeholder='Inserisci il tuo cognome' 
                  value={surname} 
                  onChange={e => setSurname(e.target.value)}
                />

                <h5>Partita IVA</h5>
                <input type="text"
                  placeholder='Inserisci la tua PI' 
                  value={PI}
                  onChange={e => setPI(e.target.value)}
                />

                <h5>Codice Fiscale</h5>
                <input 
                  type='text' 
                  placeholder='Inserisci il tuo CF' 
                  value={CF} 
                  onChange={e => setCF(e.target.value)}
                />

                <h5>Indirizzo</h5>
                {isLoaded ? (
                  <Autocomplete
                    onLoad={onLoad}
                    onPlaceChanged={onPlaceChanged}
                    options={{
                        componentRestrictions: { country: 'it' },
                    }}
                  >
                    <input 
                      type='text'
                      placeholder='Inserisci il tuo indirizzo'
                      value={indirizzo}
                      onChange={e => {
                        setIndirizzo(e.target.value);
                        setLat(null);
                        setLng(null);
                        setCap('');
                        setCitta('');
                      }}
                      style={{
                        width: "90%",
                        height: "40px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "8px"
                      }}
                    />
                  </Autocomplete>
                ) : (
                  <input 
                      type='text' 
                      placeholder="Caricamento Mappe..."
                      disabled
                      style={{
                        width: "100%",
                        height: "40px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "8px"
                      }}
                  />
                )}

                <h5>E-mail</h5>
                <input 
                  type='email' 
                  placeholder='Inserisci la tua e-mail' 
                  value={email} 
                  onChange={e => setEmail(e.target.value)}
                />

                <h5>Password</h5>
                <input 
                  type='password' 
                  placeholder='Inserisci la password' 
                  value={password} 
                  onChange={e => setPassword(e.target.value)}
                />

                {/* Bottoni per termini e condizioni */}
                <div style={{ marginTop: '16px', marginBottom: '16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', cursor: 'pointer', fontSize: '13px', lineHeight: '1.4' }}>
                    <input
                      type='checkbox'
                      checked={privacyAccepted}
                      onChange={e => setPrivacyAccepted(e.target.checked)}
                      style={{ marginTop: '2px', cursor: 'pointer' }}
                    />
                    <span>
                      Ho letto e compreso l'
                      <a 
                        href="/privacy/Informativa_Privacy_Total_Service_SRL.pdf" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ color: '#0066c0', textDecoration: 'underline' }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        Informativa Privacy
                      </a>
                    </span>
                  </label>

                  <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', cursor: 'pointer', fontSize: '13px', lineHeight: '1.4' }}>
                    <input
                      type='checkbox'
                      checked={termsAccepted}
                      onChange={e => setTermsAccepted(e.target.checked)}
                      style={{ marginTop: '2px', cursor: 'pointer' }}
                    />
                    <span>
                      Accetto i{' '}
                      <a 
                        href="/terms/Termini_e_Condizioni_Ecommerce_Total_Service_SRL.pdf" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ color: '#0066c0', textDecoration: 'underline' }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        Termini e le Condizioni di vendita
                      </a>
                    </span>
                  </label>
                </div>

                <button 
                  type='submit' 
                  className='loginButton'
                  disabled={!isFormReady}
                  style={{
                    opacity: isFormReady ? 1 : 0.5,
                    cursor: isFormReady ? 'pointer' : 'not-allowed'
                  }}
                >
                  registrati
                </button>
            </form>
          </div>
        </div>
      </div>
    );
}

export default Sign_in;
